exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section-content a{--tw-text-opacity:1;color:rgba(191,156,95,var(--tw-text-opacity));text-decoration:underline}", ""]);

// exports
